// src/utils/buyCoin.js
import { set_iframe_popup } from "../features/iframe/iframeSlice";
export function buyCoin(wallet_address, dispatch) {
  if (!wallet_address) return;
  let view = "&view=buy";
  let url = `https://buy.transfi.com/?apiKey=8p3JwJcfbczLGtV4&cryptoTicker=USDP&cryptoNetwork=USDP&walletAddress=${wallet_address}${view}`;
  dispatch(set_iframe_popup({ src: url, type: "bank_transfer" }));
}